// components
import { InputWithLabel } from "@components/Form"
import { CountrySelect } from "../Auth/SignUpForm/UserDetailsForms/CountrySelect"
import { ProvinceSelect } from "../Auth/SignUpForm/UserDetailsForms/ProvinceSelect"

const AddressInfo = ({ watch, control, errors, setValue }) => {
  return (
    <>
      <div className="w-full md:max-w-[20.12rem] gap-4 flex flex-col bg-[--pure-white] p-4 md:p-0 rounded-2xl border border-[--border-theme-300] md:border-0">
        <h2 className="text-xs font-medium text-[--text-light-gray]">
          ADDRESS INFO
        </h2>
        <div className="flex justify-between gap-3 md:gap-5">
          {/* Country */}
          <CountrySelect
            control={control}
            errors={errors}
            setValue={setValue}
            disabled={true}
            inputClassName="bg-[#EFF0F0] border-0"
          />
          {/* State */}
          <ProvinceSelect
            watch={watch}
            control={control}
            errors={errors}
            inputClassName="bg-[#EFF0F0] border-0"
            disabled={true}
          />
        </div>

        {/* Pincode */}
        <InputWithLabel
          label="Pincode"
          name="pincode"
          rules={{
            required: "Pincode is required",
            pattern: {
              value: /^[a-zA-Z0-9]*$/,
              message: "Pincode must be alphanumeric",
            },
            minLength: {
              value: 1,
              message: "Pincode must be at least 1 character",
            },
            maxLength: {
              value: 30,
              message: "Pincode must be at most 30 characters",
            },
          }}
          type="text"
          placeholder="500075"
          control={control}
          errors={errors}
          inputClassName="tracking-[12.5px] uppercase bg-[#EFF0F0] border-0"
          containerClassName="w-1/2"
          isRequired
          disabled={true}
        />
        {/* Address */}
        <InputWithLabel
          label="Address"
          name="address"
          rules={{
            required: "Address is required",
            minLength: {
              value: 5,
              message: "Address must be at least 5 characters",
            },
            maxLength: {
              value: 60,
              message: "Address must be at most 60 characters",
            },
          }}
          type="text"
          placeholder="Add apartment, suite, unit, or additional details"
          control={control}
          errors={errors}
          isRequired
          inputClassName="bg-[#EFF0F0] border-0"
          disabled={true}
        />
      </div>
    </>
  )
}

export default AddressInfo
